<div class="content-wrapper dashboard-wrapper position-relative container-xxl p-0">
  <app-skeleton class="dashboard-section-loader" *ngIf="loading" [section]="'dashboard_wrapper_loader'"></app-skeleton>
  <div class="content-body" appMuuri [style.opacity]="loading ? 0 : 1">
    <div class="dashboard-grid grid-100" appMuuriItems sort-id="UploadDocument" show-widget="1">
      <div class="m-75">
        <div class="card card-transition fileUploadWidget_dashboard m-0">
          <!-- Upload Document Widget -->
          <app-uploaddocumentwidget *ngIf="(dashboardSettings | async)?.UploadDocument === 'active'"></app-uploaddocumentwidget>
        </div>
      </div>
    </div>
    <!-- </ng-container> -->

    <div class="dashboard-grid grid-50" appMuuriItems sort-id="LatestActivity">
      <div class="m-75">
        <div class="card card-transition heightfor-250 m-0">
          <!-- Latest Activity Widget -->
          <app-latestactivitywidget *ngIf="(dashboardSettings | async)?.LatestActivity === 'active'"></app-latestactivitywidget>
        </div>
      </div>
    </div>
    <div class="dashboard-grid grid-50" appMuuriItems sort-id="TaskReminders">
      <div class="m-75">
        <div class="card card-transition heightfor-250 m-0">
          <!-- Task & Reminders Widget -->
          <app-taskandreminderswidget *ngIf="(dashboardSettings | async)?.TaskReminders === 'active'"></app-taskandreminderswidget>
        </div>
      </div>
    </div>
    <div class="dashboard-grid grid-50" appMuuriItems sort-id="AutoRenewalOn">
      <div class="m-75">
        <div class="card card-transition heightfor-250 m-0 autorenewalon-widget">
          <!-- Auto Renewal On Widget -->
          <app-autorenewalonwidget *ngIf="(dashboardSettings | async)?.AutoRenewalOn === 'active'"></app-autorenewalonwidget>
        </div>
      </div>
    </div>
    <div class="dashboard-grid grid-50" appMuuriItems sort-id="ExpiresOn">
      <div class="m-75">
        <div class="card card-transition heightfor-250 m-0 expireson-widget">
          <!-- Expires Widget -->
          <app-expiresonwidget *ngIf="(dashboardSettings | async)?.ExpiresOn === 'active'"></app-expiresonwidget>
        </div>
      </div>
    </div>
    <div class="dashboard-grid grid-50" appMuuriItems sort-id="ForgottenDocuments">
      <div class="m-75">
        <div class="card card-transition heightfor-250 m-0 forgotDocument-widget">
          <!-- Forgottend Document Widget -->
          <app-forgottendocumentwidget *ngIf="(dashboardSettings | async)?.ForgottenDocuments === 'active'"></app-forgottendocumentwidget>
        </div>
      </div>
    </div>
    <div class="dashboard-grid grid-50" appMuuriItems sort-id="LastSignedDocuments">
      <div class="m-75">
        <div class="card card-transition heightfor-250 m-0 lastSignedDocument-widget">
          <!-- Last Signed Document Widget -->
          <app-lastsigneddocumentwidget *ngIf="(dashboardSettings | async)?.LastSignedDocuments === 'active'"></app-lastsigneddocumentwidget>
        </div>
      </div>
    </div>
    <div class="dashboard-grid grid-50" appMuuriItems sort-id="MostActiveUsers">
      <div class="m-75">
        <div class="card card-transition heightfor-250 m-0 mostActiveUsers-widget">
          <!-- Most Active Users Widget -->
          <app-mostactiveuserswidget *ngIf="(dashboardSettings | async)?.MostActiveUsers === 'active'"></app-mostactiveuserswidget>
        </div>
      </div>
    </div>
    <div class="dashboard-grid grid-50" appMuuriItems sort-id="UnreadChatMessages">
      <div class="m-75">
        <div class="card card-transition heightfor-250 m-0 unreadChatMessage-widget">
          <!-- Unread Chat Message Widget -->
          <app-unreadchatmessagewidget *ngIf="(dashboardSettings | async)?.UnreadChatMessages === 'active'"></app-unreadchatmessagewidget>
        </div>
      </div>
    </div>
    <div class="dashboard-grid grid-50" appMuuriItems sort-id="AbouttoExpire">
      <div class="m-75">
        <div class="card card-transition heightfor-250 m-0 aboutToExpire-widget">
          <!-- About To Expire Widget -->
          <app-abouttoexpirewidget *ngIf="(dashboardSettings | async)?.AbouttoExpire === 'active'"></app-abouttoexpirewidget>
        </div>
      </div>
    </div>
    <div class="dashboard-grid grid-50" appMuuriItems sort-id="EmailBounced">
      <div class="m-75">
        <div class="card card-transition heightfor-250 m-0 emailBounced-widget">
          <!-- Emai Bbounced Widget -->
          <app-emailbouncedwidget *ngIf="(dashboardSettings | async)?.EmailBounced === 'active'"></app-emailbouncedwidget>
        </div>
      </div>
    </div>
    <div class="dashboard-grid grid-50" appMuuriItems sort-id="MostUsedTemplates">
      <div class="m-75">
        <div class="card card-transition heightfor-250 m-0 mostUsedTemplates-widget">
          <!-- Most Used Template Widget -->
          <app-mostusedtemplateswidget *ngIf="(dashboardSettings | async)?.MostUsedTemplates === 'active'"></app-mostusedtemplateswidget>
        </div>
      </div>
    </div>
    <div class="dashboard-grid grid-50" appMuuriItems sort-id="ContractControl">
      <div class="m-75">
        <div class="card card-transition m-0 heightfor-250 -widget">
          <!-- Contract Control Widget -->
          <app-contractcontrolwidget *ngIf="(dashboardSettings | async)?.ContractControl === 'active'"></app-contractcontrolwidget>
        </div>
      </div>
    </div>
    


    <!-- dashboard customizer -->
  
    <a class="customizer-toggle cursor-pointer d-flex align-items-center justify-content-center"
      placement="auto" container="body" [autoClose]="true" triggers="hover" ngbTooltip="Dashboard customize" 
      (click)="dashboardSidebar('dashboardCustomizer')">
      <span [data-feather]="'grid'">
      </span>
    </a>

    <core-sidebar 
      name="dashboardCustomizer" class="modal modal-slide-in productLibrarysidebar-modal fade"
      overlayClass="modal-backdrop">
      <app-dashboard-customizer-sidebar></app-dashboard-customizer-sidebar>
    </core-sidebar>

    <!-- / dashboard customizer -->
  </div>
</div>